import { Loader } from '@grafikr/components';

export default Loader((_, load) => {
  load();
});
